
import { Search, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface NetworkRulesFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  onAddClick?: () => void;
}

export const NetworkRulesFilters = ({ searchTerm, setSearchTerm, onAddClick }: NetworkRulesFiltersProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <Input
          placeholder="Search rules or apps..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-black/20"
        />
      </div>
      {onAddClick && (
        <Button onClick={onAddClick} className="flex items-center space-x-2">
          <Plus className="w-4 h-4" />
          <span>Add Rule</span>
        </Button>
      )}
    </div>
  );
};
